// extracted by mini-css-extract-plugin
module.exports = {"searchInput":"smartsearch_searchInput___pyeu","focus:sm":"smartsearch_focus__sm__HOq6d","expand":"smartsearch_expand__E_DVd"};